var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5H29M12 12.5V22.5C12 23.0304 12.2107 23.5391 12.5858 23.9142C12.9609 24.2893 13.4696 24.5 14 24.5H26C26.5304 24.5 27.0391 24.2893 27.4142 23.9142C27.7893 23.5391 28 23.0304 28 22.5V12.5M20 24.5V28.5M17 28.5H23",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5L19 17.5L21 19.5L24 16.5",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationIcon);
export default __webpack_public_path__ + "static/media/presentation_icon.46aec11cee34de4903d24c8ef2d01fbe.svg";
export { ForwardRef as ReactComponent };